export default __webpack_public_path__ + "media/zurb/img/ecommerce/jab_5-c8bb21188f055d50c1433d3748289f00.png";